var _defs, _line, _rect, _g, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapIcon3 = function SvgMapIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_95",
    "data-name": "Group 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.24,
    height: 16.684,
    viewBox: "0 0 31.24 16.684"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 31.24,
    height: 16.683,
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x2: 17.775,
    transform: "translate(7.017 8.49)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 2.828,
    height: 7.962,
    transform: "translate(4.35 4.509)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 2.828,
    height: 15.163,
    transform: "translate(0.76 0.76)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 2.828,
    height: 15.163,
    transform: "translate(27.65 0.76)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 2.828,
    height: 7.962,
    transform: "translate(24.498 4.509)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })));
};

export { SvgMapIcon3 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfOTUiIGRhdGEtbmFtZT0iR3JvdXAgOTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIzMS4yNCIgaGVpZ2h0PSIxNi42ODQiIHZpZXdCb3g9IjAgMCAzMS4yNCAxNi42ODQiPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwLXBhdGgiPgogICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzE1MyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTUzIiB3aWR0aD0iMzEuMjQiIGhlaWdodD0iMTYuNjgzIiBmaWxsPSJub25lIiBzdHJva2U9IiNlYmRkYmIiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPGxpbmUgaWQ9IkxpbmVfMTA0IiBkYXRhLW5hbWU9IkxpbmUgMTA0IiB4Mj0iMTcuNzc1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjAxNyA4LjQ5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZWJkZGJiIiBzdHJva2Utd2lkdGg9IjEiLz4KICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzE1MCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTUwIiB3aWR0aD0iMi44MjgiIGhlaWdodD0iNy45NjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuMzUgNC41MDkpIiBmaWxsPSJub25lIiBzdHJva2U9IiNlYmRkYmIiIHN0cm9rZS13aWR0aD0iMSIvPgogIDxnIGlkPSJHcm91cF85NCIgZGF0YS1uYW1lPSJHcm91cCA5NCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+CiAgICA8ZyBpZD0iR3JvdXBfOTMiIGRhdGEtbmFtZT0iR3JvdXAgOTMiIGNsaXAtcGF0aD0idXJsKCNjbGlwLXBhdGgpIj4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNTEiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE1MSIgd2lkdGg9IjIuODI4IiBoZWlnaHQ9IjE1LjE2MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC43NiAwLjc2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZWJkZGJiIiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNTIiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE1MiIgd2lkdGg9IjIuODI4IiBoZWlnaHQ9IjE1LjE2MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjcuNjUgMC43NikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ViZGRiYiIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8L2c+CiAgPC9nPgogIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTU0IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNTQiIHdpZHRoPSIyLjgyOCIgaGVpZ2h0PSI3Ljk2MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQuNDk4IDQuNTA5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZWJkZGJiIiBzdHJva2Utd2lkdGg9IjEiLz4KPC9zdmc+Cg==";